import Image from './Image';
import orientation from './orientation';
import clipSpot from './spot';
import edit from './Editor';

Image.orientation = orientation;
Image.clipSpot = clipSpot;
Image.edit = edit;

export default Image;